import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';

interface MarketingLayoutProps {
  children?: ReactNode;
}

const MarketingLayout: FC<MarketingLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Navbar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: 8, md: 10 },
        }}
      >
        {children || <Outlet />}
      </Box>
      <Footer />
    </Box>
  );
};

export default MarketingLayout;
